export default __webpack_public_path__ + "static/media/NH06.d5f81a1e.jpg";